import PropTypes from "prop-types";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Toaster from "../../Components/Toaster";
import { TextField, Box, Stack, InputAdornment } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import PersonIcon from "@mui/icons-material/Person";
import Buttons from "../../Components/Button/Buttons";
import {
  vendorRegistration,
  forgetPasswordVendorCode,
} from "../../../serviceFile/ApiService";

const VendorRegistration = ({ isForgetPassword }) => {
  const [vendorCodeErr, setVendorCodeErr] = useState(""); // state used to maintain errors
  const [vendorCode, setVendorCode] = useState(""); // state used for store vendor code
  const navigate = useNavigate();
  // vendor code submission function
  const handleSubmit = (e) => {
    e.preventDefault();
    if (vendorCode.trim().length === 0) {
      setVendorCodeErr("Vendor code is required");
      return;
    }
    if (vendorCodeErr !== "") {
      return;
    } else if (isForgetPassword === true) {
      forgetPasswordVendorCode(vendorCode)
        .then((res) => {
          localStorage.setItem("vendorCode", vendorCode);
          const message = res?.data?.message;
          if (message === "Already Registered") {
            Toaster("You have already registered!", 101, ["warning"]);
          } else if (res?.data?.status === 404) {
            Toaster(message, 109, ["error"]);
          } else {
            Toaster("OTP sent successfully", 101, ["success"]);
            navigate(`/Registration/OtpVerification?isForgotpassword=${true}`, {
              replace: true,
            });
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    } else {
      vendorRegistration(vendorCode)
        .then((res) => {
          localStorage.setItem("vendorCode", vendorCode);
          const message = res?.data?.message;
          if (message === "Already Registered") {
            Toaster("You have already registered!", 101, ["warning"]);
          } else if (res?.data?.status === 404) {
            Toaster(message, 101, ["error"]);
          } else {
            Toaster("OTP sent successfully", 101, ["success"]);
            navigate("/Registration/OtpVerification", { replace: true });
          }
        })
        .catch((err) => {
          const errorMessage = err?.response?.data?.message;
          if (err?.response?.data?.status === 404) {
            Toaster(errorMessage, 134, ["error"]);
          } else {
            Toaster("Sorry something went wrong!", 134, ["error"]);
          }
        });
    }
  };

  // function to handle vendor code validations
  const handleVendorCode = (e) => {
    const inputValue = e.target.value;
    let vendorCodeCheck = new RegExp(/^\d+(?: \s\d+)*$/).test(inputValue);
    setVendorCode(inputValue);
    const vendorCd = inputValue.trim();
    if (vendorCd === "" || vendorCd === null) {
      setVendorCodeErr("Vendor code is required");
      setVendorCode("");
    } else if (!vendorCodeCheck) {
      setVendorCodeErr("Please enter valid vendor code");
    } else {
      setVendorCodeErr("");
      setVendorCode(inputValue);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "start",
        alignItems: "center",
      }}
    >
      <Stack spacing={3} direction="row" width="100%">
        <Stack
          direction="column"
          spacing={2}
          sx={{ marginTop: "30px !important", width: "50%" }}
        >
          <TextField
            value={vendorCode}
            id="outlined-basic"
            label="Vendor code"
            variant="outlined"
            autoComplete="off"
            alignItems="center"
            justifyContent="center"
            sx={{ width: { xs: "250px", sm: "300px" } }}
            size="medium"
            InputProps={{
              shrink: true,
              startAdornment: (
                <InputAdornment position="start">
                  <PersonIcon style={{ color: "rgb(64, 132, 255)" }} />
                </InputAdornment>
              ),
            }}
            error={!!vendorCodeErr}
            helperText={vendorCodeErr}
            onChange={(e) => handleVendorCode(e)}
          />
          <Buttons
            onClick={handleSubmit}
            endIcon={<SendIcon />}
            sx={{ width: { xs: "250px", sm: "300px", marginTop: "-20px" } }}
            text="Generate OTP"
          />
        </Stack>
        <Stack
          sx={{
            width: "50%",
            display: { xs: "none", sm: "block" },
          }}
        >
          <img
            src="/assets/images/login-image.png"
            alt="LoginImage"
            style={{
              width: "350px",
              height: "350px",
              marginTop: "-30px",
              marginLeft: "20px",
            }}
          ></img>
        </Stack>
      </Stack>
    </Box>
  );
};

VendorRegistration.propTypes = {
  isForgetPassword: PropTypes.bool,
};

export default VendorRegistration;
